import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
interface CTAButtonProps {
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  className = '',
  onClick
}: CTAButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={() => {
    if (onClick) {
      onClick();
    } else {
      document.getElementById('compra-final')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }} className={`group relative inline-flex items-center justify-center gap-3 bg-emerald hover:bg-emerald-dark text-white px-8 py-4 rounded-full font-bold text-lg shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden ${className}`} data-id="element-31">
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out" data-id="element-32" />
      <ShoppingCart className="w-6 h-6 relative z-10" data-id="element-33" />
      <span className="relative z-10" data-id="element-34">¡Sí, quiero el detox $9.99!</span>
    </motion.button>;
}